import fetchWithAuth from './base';
import type { ClientEntitlement } from '@/types/entitlement';

export async function getClientEntitlement(clientId: string): Promise<ClientEntitlement> {
  const response = await fetchWithAuth(`/api/client/${clientId}/entitlement`, {
    method: 'GET',
  });

  return response.json();
}
